import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import * as S from './Modal.styles';
import { Close } from 'styled-icons/ionicons-outline';

export type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  successText?: string;
  closeText?: string;
  onSuccess?: () => void;
};

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  successText = 'Confirmar',
  closeText = 'Fechar',
  onSuccess,
}) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };

  const modalContent = (
    <S.Overlay ref={overlayRef} onClick={handleOverlayClick}>
      <S.ModalContainer>
        <S.ModalHeader>
          <S.ModalTitle>{title}</S.ModalTitle>
          <S.CloseIconWrapper onClick={onClose} aria-label="Fechar">
            <Close size={24} />
          </S.CloseIconWrapper>
        </S.ModalHeader>
        <S.ModalContent>{children}</S.ModalContent>
        <S.ModalFooter>
          <S.CustomButton variant="secondary" onClick={onClose}>
            {closeText}
          </S.CustomButton>
          <S.CustomButton onClick={onSuccess}>{successText}</S.CustomButton>
        </S.ModalFooter>
      </S.ModalContainer>
    </S.Overlay>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};
